/// <reference path="../lib/jquery.d.ts" />


export class CmsContentControl {

    constructor() {
        
        $('main').children('.contentHolder').last().addClass("last-element");
    }
}